import { render } from "./Lattice.svg?vue&type=template&id=01bb2a67"
const script = {}
script.render = render

export default script